var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreTradingEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st16{fill:#fff}.st17{fill:none;stroke:#fff;stroke-miterlimit:10}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000013164409798743127500000001372141005010138799_",
    transform: "rotate(-45.001 50.58 50.156)",
    d: "M7.7 7.3h85.7V93H7.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162341469611486606920000005909339840813127851_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013164409798743127500000001372141005010138799_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162341469611486606920000005909339840813127851_)",
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6,
      strokeLinecap: "round"
    },
    d: "M16.3 61.6c0 12.6 10.2 22.9 22.9 22.9h22.9C74.7 84.5 85 74.3 85 61.6V38.7c0-12.6-10.2-22.9-22.9-22.9H39.2c-12.6 0-22.9 10.2-22.9 22.9v22.9z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M36.9 33.6c1.6 0 3 1.4 3 3v32c0 1.7-1.4 3-3 3h-3c-1.7 0-3-1.3-3-3v-32c0-1.6 1.4-3 3-3h3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M36.9 33.6c1.6 0 3 1.4 3 3v32c0 1.7-1.4 3-3 3h-3c-1.7 0-3-1.3-3-3v-32c0-1.6 1.4-3 3-3h3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M51.9 39.6c1.6 0 3 1.4 3 3v26c0 1.7-1.4 3-3 3h-3c-1.7 0-3-1.3-3-3v-26c0-1.6 1.3-3 3-3h3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M51.9 39.6c1.6 0 3 1.4 3 3v26c0 1.7-1.4 3-3 3h-3c-1.7 0-3-1.3-3-3v-26c0-1.6 1.3-3 3-3h3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M66.9 27.6c1.7 0 3 1.4 3 3v38c0 1.7-1.3 3-3 3h-3c-1.7 0-3-1.3-3-3v-38c0-1.6 1.3-3 3-3h3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M66.9 27.6c1.7 0 3 1.4 3 3v38c0 1.7-1.3 3-3 3h-3c-1.7 0-3-1.3-3-3v-38c0-1.6 1.3-3 3-3h3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreTradingEvent);
export default __webpack_public_path__ + "static/media/exploreTradingEvent.371960f85cb83fc8edf08399fd1c6760.svg";
export { ForwardRef as ReactComponent };